import React from 'react';
import PropTypes from 'prop-types';
import { ReactSVG } from 'react-svg';
import Modal from 'common-ui-components/dist/components/Atoms/Modal';
import Button from 'common-ui-components/dist/components/Atoms/Button';
import Anchor from 'common-ui-components/dist/components/Atoms/Anchor';
import './EndSessionModal.scss';

const EndSessionModal = props => {
  const {
    labels,
    config,
    endProcurementSession,
    endSessionModalStatus,
    setEndSessionModalStatus,
  } = props;
  const { removeAllItemsIconUrl } = config;
  const { endSessionTitle, endSessionMessage, endSession, cancel } = labels;
  const modalProps = {
    className: 'modal__Content end-session-modal',
    isOpen: endSessionModalStatus,
    onRequestClose: () => setEndSessionModalStatus(false),
    elementLocator: 'end-session',
  };
  const buttonProps = {
    className: 'primary',
    elementLocator: 'end-session-button',
    onClick: () => endProcurementSession(),
  };
  const anchorProps = {
    to: '#',
    className: 'end-session-link',
    elementLocator: 'cancel',
    onClick: () => setEndSessionModalStatus(false),
  };
  return (
    <Modal {...modalProps}>
      <>
        <div className="col-xs-12 modal-heading">
          <ReactSVG
            src={removeAllItemsIconUrl}
            className="heading-icon"
            data-locator="header-icon"
          />
          <h2 data-locator="end-session">{endSessionTitle}</h2>
        </div>
        <div className="col-xs-12 end-session-modal-message" data-locator="modal-information-text">
          {endSessionMessage}
        </div>
        <div className="col-xs-12 end-session-button">
          <Button {...buttonProps}>{endSession}</Button>
        </div>
        <div className="col-xs-12 end-session-button">
          <Anchor {...anchorProps}>{cancel}</Anchor>
        </div>
      </>
    </Modal>
  );
};

EndSessionModal.propTypes = {
  labels: PropTypes.objectOf(PropTypes.string),
  config: PropTypes.objectOf(PropTypes.string),
  endSessionModalStatus: PropTypes.bool,
  endProcurementSession: PropTypes.func,
  setEndSessionModalStatus: PropTypes.func,
};

EndSessionModal.defaultProps = {
  labels: {},
  config: {},
  endSessionModalStatus: false,
  setEndSessionModalStatus: () => {
    /* default setEndSessionModalStatus handler */
  },
  endProcurementSession: () => {
    /* default setEndSessionModalStatus handler */
  },
};

export default EndSessionModal;
